import { Grid, makeStyles, Theme } from "@material-ui/core";
import { useDocumentStore } from "@roc/feature-documents";
import { CurrencyField, TextField } from "@roc/ui";
import { observer } from "mobx-react";

const useStyles = makeStyles((theme: Theme) => ({
}));

export const EditPayoffFieldsForm = observer(({ }) => {
  const classes = useStyles();

  const {
    documentStore: {
      documentFormStore: { payoffCalculatorStore: { payoffFieldsFormStore } },
    },
  } = useDocumentStore();

  return (
    <div>
      <Grid container direction="row" spacing={1}>
        <Grid item xs={6}>
          <CurrencyField
            testId={'totalExtensionFee'}
            variant={'outlined'}
            label={'Total Extension Fee'}
            standaloneLabel
            value={payoffFieldsFormStore.form.fields.totalExtensionFee.value}
            onChange={(name, value) => payoffFieldsFormStore.onFieldChange('totalExtensionFee', Number(value))}
            fullWidth
            allowNegative
          />
        </Grid>
        <Grid item xs={6}>
          <CurrencyField
            testId={'reservesIfAny'}
            variant={'outlined'}
            label={'Reserves Fees If Any'}
            standaloneLabel
            value={payoffFieldsFormStore.form.fields.reservesIfAny.value}
            onChange={(name, value) => payoffFieldsFormStore.onFieldChange('reservesIfAny', Number(value))}
            fullWidth
            allowNegative
          />
        </Grid>
        <Grid item xs={6}>
          <CurrencyField
            testId={'prepaymentPenalty'}
            variant={'outlined'}
            label={'Prepayment Penalty'}
            standaloneLabel
            value={payoffFieldsFormStore.form.fields.prepaymentPenalty.value}
            onChange={(name, value) => payoffFieldsFormStore.onFieldChange('prepaymentPenalty', Number(value))}
            fullWidth
            allowNegative
          />
        </Grid>
        <Grid item xs={6}>
          <CurrencyField
            testId={'toChargesPrincipal'}
            variant={'outlined'}
            label={'To Charges Principal'}
            standaloneLabel
            value={payoffFieldsFormStore.form.fields.toChargesPrincipal.value}
            onChange={(name, value) => payoffFieldsFormStore.onFieldChange('toChargesPrincipal', Number(value))}
            fullWidth
            allowNegative
          />
        </Grid>
        <Grid item xs={6}>
          <CurrencyField
            testId={'waiverAmount'}
            variant={'outlined'}
            label={'Waiver Amount'}
            standaloneLabel
            value={payoffFieldsFormStore.form.fields.waiverAmount.value}
            onChange={(name, value) => payoffFieldsFormStore.onFieldChange('waiverAmount', Number(value))}
            fullWidth
            allowNegative
          />
        </Grid>
        <Grid item xs={6}>
          <CurrencyField
            testId={'otherFeesAdjustment'}
            variant={'outlined'}
            label={'Other Fees'}
            standaloneLabel
            value={payoffFieldsFormStore.form.fields.otherFeesAdjustment.value}
            onChange={(name, value) => payoffFieldsFormStore.onFieldChange('otherFeesAdjustment', Number(value))}
            fullWidth
            allowNegative
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            standaloneLabel
            variant="outlined"
            label="Waiver Description"
            value={payoffFieldsFormStore.form.fields.waiverDescription.value}
            onChange={(e) => payoffFieldsFormStore.onFieldChange('waiverDescription', e.target.value)}
            multiline
            rows={2}
            fullWidth
            testId='waiverDescription'
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            standaloneLabel
            variant="outlined"
            label="Other Fees Categories"
            value={payoffFieldsFormStore.form.fields.otherFeesCategories.value}
            onChange={(e) => payoffFieldsFormStore.onFieldChange('otherFeesCategories', e.target.value)}
            multiline
            rows={2}
            fullWidth
            testId='otherFeesCategories'
          />
        </Grid>
        <Grid item xs={6}>
          <CurrencyField
            testId={'crossInterest'}
            variant={'outlined'}
            label={'Cross Interest'}
            standaloneLabel
            value={payoffFieldsFormStore.form.fields.crossInterest.value}
            onChange={(name, value) => payoffFieldsFormStore.onFieldChange('crossInterest', Number(value))}
            fullWidth
            allowNegative
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            standaloneLabel
            variant="outlined"
            label="Comments"
            value={payoffFieldsFormStore.form.fields.payoffComments.value}
            onChange={(e) => payoffFieldsFormStore.onFieldChange('payoffComments', e.target.value)}
            multiline
            rows={2}
            fullWidth
            testId='payoffComments'
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            standaloneLabel
            variant="outlined"
            label="Cross Interest Detail"
            value={payoffFieldsFormStore.form.fields.crossInterestDetail.value}
            onChange={(e) => payoffFieldsFormStore.onFieldChange('crossInterestDetail', e.target.value)}
            multiline
            rows={2}
            fullWidth
            testId='crossInterestDetail'
          />
        </Grid>
      </Grid>
    </div>
  );
});
